import React from "react";
import Select from "react-select";
import InputField from "../../../../../../components/InputField";
import SelectField from "../../../../../../components/SelectField";
import Button from "../../../../../../components/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DatePicker from "react-datepicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "react-datepicker/dist/react-datepicker.css";
import { selectPortalStyles } from "../constants";

const DatePickerField = ({ selected, onChange, placeholder, error }) => (
  <div style={{ position: "relative", width: "100%" }}>
    <DatePicker
      selected={selected}
      onChange={onChange}
      dateFormat="dd/MM/yyyy"
      wrapperClassName="w-100"
      className={`form-control w-100 ${error ? "is-invalid" : ""}`}
      placeholderText="DD/MM/YYYY"
      calendarClassName="custom-calendar"
    />
    <CalendarMonthIcon
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        pointerEvents: "none",
        color: "#6c757d",
      }}
    />
  </div>
);

const VendorPurchaseForm = ({
  vendors,
  vendorIndex,
  vendor,
  vendorTotal,
  purchasesLength,
  vendorOptions,
  loadingVendors,
  chargeCodeOptions,
  currencyOptions,
  containerOptions,
  loadingChargeCodes,
  loadingCurrencies,
  vendorInvoiceDates,
  setVendorInvoiceDates,
  errors,
  removeVendor,
  updateVendor,
  updateVendorInputCharge,
  handleVendorChargeInputChange,
  addChargeRow,
  deleteChargeRow,
  handleVendorSelect,
  fetchGSTForChargeCode,
  setVendors,


}) => {
  return (
    <div
      className="vendor-section mb-5"
      style={{
        border: "1px solid #dee2e6",
        borderRadius: 8,
        padding: 20,
        overflow: "visible",
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 border-bottom pb-2">
          As Per Vendor {purchasesLength + vendorIndex + 1}
        </h5>
        {vendors.length > 0 && (
          <Button
            variant="contained"
            btncls="bg-danger text-white px-3 py-1 vendor-remove-btn"
            size="small"
            onClick={() => removeVendor(vendor.id)}
          >
            Remove
          </Button>
        )}
      </div>

      {/* Vendor Metadata Fields */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <label className="form-label">Vendor Name</label>
          <Select
            options={vendorOptions}
            value={
              vendorOptions.find((v) => v.value === vendor.vendor_id) ||
              (vendor.vendor_id
                ? { value: vendor.vendor_id, label: vendor.vendor_name }
                : null)
            }
            onChange={(selected) => handleVendorSelect(selected, vendor.id)}
            placeholder="Select Vendor"
            isLoading={loadingVendors}
            isClearable
            menuPortalTarget={document.body}
            styles={selectPortalStyles}
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Vendor Location"
            value={vendor.vendor_location}
            onChange={(e) => updateVendor(vendor.id, "vendor_location", e.target.value)}
            placeholder="Enter Vendor Location"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="GST Number"
            value={vendor.gst_number}
            onChange={(e) => updateVendor(vendor.id, "gst_number", e.target.value)}
            placeholder="Enter GST Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="PAN Number"
            value={vendor.pan_number}
            onChange={(e) => updateVendor(vendor.id, "pan_number", e.target.value)}
            placeholder="Enter PAN Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Vendor Invoice Number"
            value={vendor.voucher_invoice_number}
            onChange={(e) => updateVendor(vendor.id, "voucher_invoice_number", e.target.value)}
            placeholder="Enter Vendor Invoice Number"
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">Vendor Invoice Date</label>
          <DatePickerField
            selected={vendorInvoiceDates[vendorIndex] || null}
            onChange={(date) => {
              const newDates = [...vendorInvoiceDates];
              newDates[vendorIndex] = date;
              setVendorInvoiceDates(newDates);
              updateVendor(vendor.id, "voucher_invoice_date", date);
            }}
            placeholder="DD/MM/YYYY"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Vendor Booking Number"
            value={vendor.vb_number}
            onChange={(e) => updateVendor(vendor.id, "vb_number", e.target.value)}
            placeholder="Enter Vendor Booking Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Vendor Job Number"
            value={vendor.vendor_job_number}
            onChange={(e) => updateVendor(vendor.id, "vendor_job_number", e.target.value)}
            placeholder="Enter Vendor Job Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Master Shipper"
            value={vendor.shipper}
            onChange={(e) => updateVendor(vendor.id, "shipper", e.target.value)}
            placeholder="Enter Master Shipper"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Master Consignee"
            value={vendor.consignee}
            onChange={(e) => updateVendor(vendor.id, "consignee", e.target.value)}
            placeholder="Enter Master Consignee"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Master BL Number"
            value={vendor.mbl_number}
            onChange={(e) => updateVendor(vendor.id, "mbl_number", e.target.value)}
            placeholder="Enter Master BL Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Vessel Name"
            value={vendor.vessel_name}
            onChange={(e) => updateVendor(vendor.id, "vessel_name", e.target.value)}
            placeholder="Enter Vessel Name"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Vessel Number"
            value={vendor.vessel_number}
            onChange={(e) => updateVendor(vendor.id, "vessel_number", e.target.value)}
            placeholder="Enter Vessel Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Voyage Number"
            value={vendor.voyage_number}
            onChange={(e) => updateVendor(vendor.id, "voyage_number", e.target.value)}
            placeholder="Enter Voyage Number"
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Estimated Date"
            name="etd_date"
            type="date"
            value={vendor.etd_date}
            onChange={(e) => updateVendor(vendor.id, "etd_date", e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <InputField
            label="Cut Off Date"
            name="cut_off_date"
            type="date"
            value={vendor.cut_off_date || ""}
            onChange={(e) => updateVendor(vendor.id, "cut_off_date", e.target.value)}
          />
        </div>
      </div>

      {/* Charge Table */}
      <div className="mb-4 position-relative" style={{ overflowX: "auto" }}>
        <table className="table table-bordered tbllbl mb-2 mb-md-3" style={{ minWidth: 1100 }}>
          <thead className="table-light">
            <tr>
              <th>Charge Code</th>
              <th>SAC Code</th>
              <th>Currency</th>
              <th>Rate</th>
              <th>Quantity</th>
              <th>Taxable Amount</th>
              <th>GST Applicable</th>
              <th>GST %</th>
              <th>GST Amount</th>
              <th>Container(s)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
     
            <tr>
              <td>
                <SelectField
                  options={chargeCodeOptions}
                  value={vendor.inputChargeRow.charge_code}
                  onChange={(val) => updateVendorInputCharge(vendor.id, "charge_code", val)}
                  isLoading={loadingChargeCodes}
                  searchable
                />
              </td>
              <td>
                <InputField
                  type="text"
                  placeholder="SAC Code"
                  value={vendor.inputChargeRow.sac_code || ""}
                  onChange={(e) => updateVendorInputCharge(vendor.id, "sac_code", e.target.value)}
                />
              </td>
              <td className="minselect">
                <Select
                  options={currencyOptions}
                  value={currencyOptions.find((c) => c.value === vendor.inputChargeRow.currency) || null}
                  onChange={(selected) => updateVendorInputCharge(vendor.id, "currency", selected?.value || "")}
                  isLoading={loadingCurrencies}
                  placeholder="Select"
                  menuPortalTarget={document.body}
                  styles={selectPortalStyles}
                />
              </td>
              <td>
                <InputField
                  type="text"
                  placeholder="Rate"
                  value={vendor.inputChargeRow.rate || ""}
                  onChange={(e) => updateVendorInputCharge(vendor.id, "rate", e.target.value)}
                />
              </td>
              <td>
                <InputField
                  type="text"
                  placeholder="Quantity"
                  value={vendor.inputChargeRow.quantity || ""}
                  onChange={(e) => updateVendorInputCharge(vendor.id, "quantity", e.target.value)}
                />
              </td>
              <td>
                <InputField
                  type="text"
                  placeholder="Amount"
                  value={vendor.inputChargeRow.taxable_amount || ""}
                  onChange={(e) => updateVendorInputCharge(vendor.id, "taxable_amount", e.target.value)}
                />
              </td>
              <td className="minselect">
                <Select
                  options={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]}
                  value={vendor.inputChargeRow.gst_applicable === "No" ? { label: "No", value: "No" } : { label: "Yes", value: "Yes" }}
                  onChange={(selected) => updateVendorInputCharge(vendor.id, "gst_applicable", selected?.value || "Yes")}
                  placeholder="Select"
                  menuPortalTarget={document.body}
                  styles={selectPortalStyles}
                />
              </td>
              <td>
                <InputField
                  type="text"
                  placeholder="GST %"
                  value={vendor.inputChargeRow.gst || ""}
                  onChange={(e) => updateVendorInputCharge(vendor.id, "gst", e.target.value)}
                  disabled={vendor.inputChargeRow.gst_applicable === "No"}
                />
              </td>
              <td>
                <InputField
                  type="text"
                  placeholder="GST Amt"
                  value={vendor.inputChargeRow.gst_applicable === "No" ? "0" : vendor.inputChargeRow.gst_amount || ""}
                  onChange={(e) => updateVendorInputCharge(vendor.id, "gst_amount", e.target.value)}
                  disabled={vendor.inputChargeRow.gst_applicable === "No"}
                />
              </td>
              <td className="minselect">
                <Select
                  isMulti
                  options={containerOptions}
                  value={containerOptions.filter((o) => (vendor.inputChargeRow.applicableContainers || []).includes(o.value)) || null}
                  onChange={(selected) => updateVendorInputCharge(vendor.id, "applicableContainers", (selected || []).map((s) => s.value))}
                  placeholder="Select Container(s)"
                  isDisabled={containerOptions.length === 0}
                  menuPortalTarget={document.body}
                  styles={selectPortalStyles}
                />
              </td>
              <td className="text-center">
                <AddCircleOutlineIcon
                  style={{ cursor: "pointer", color: "green", fontSize: 28 }}
                  onClick={() => addChargeRow(vendor.id)}
                />
              </td>
            </tr>

          
            {vendor.chargeRows.map((charge, index) => (
              <tr key={index}>
                <td>
                  <SelectField
                    options={chargeCodeOptions}
                    value={charge.charge_code}
                    onChange={(val) => {
                      handleVendorChargeInputChange(vendor.id, index, "charge_code", val);
                      fetchGSTForChargeCode(val, vendor.id, index, setVendors);
                    }}
                    isLoading={loadingChargeCodes}
                    searchable
                  />
                </td>
                <td>
                  <InputField
                    type="text"
                    value={charge.sac_code || ""}
                    onChange={(e) => handleVendorChargeInputChange(vendor.id, index, "sac_code", e.target.value)}
                  />
                </td>
                <td className="minselect">
                  <Select
                    options={currencyOptions}
                    value={currencyOptions.find((c) => c.value === charge.currency) || null}
                    onChange={(selected) => handleVendorChargeInputChange(vendor.id, index, "currency", selected?.value || "")}
                    isLoading={loadingCurrencies}
                    menuPortalTarget={document.body}
                    styles={selectPortalStyles}
                  />
                </td>
                <td>
                  <InputField type="text" value={charge.rate || ""} onChange={(e) => handleVendorChargeInputChange(vendor.id, index, "rate", e.target.value)} />
                </td>
                <td>
                  <InputField type="text" value={charge.quantity || ""} onChange={(e) => handleVendorChargeInputChange(vendor.id, index, "quantity", e.target.value)} />
                </td>
                <td>
                  <InputField type="text" value={charge.taxable_amount || ""} onChange={(e) => handleVendorChargeInputChange(vendor.id, index, "taxable_amount", e.target.value)} />
                </td>
                <td className="minselect">
                  <Select
                    options={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]}
                    value={charge.gst_applicable === "No" ? { label: "No", value: "No" } : { label: "Yes", value: "Yes" }}
                    onChange={(selected) => handleVendorChargeInputChange(vendor.id, index, "gst_applicable", selected?.value || "Yes")}
                    placeholder="Select"
                    menuPortalTarget={document.body}
                    styles={selectPortalStyles}
                  />
                </td>
                <td>
                  <InputField type="text" value={charge.gst || ""} onChange={(e) => handleVendorChargeInputChange(vendor.id, index, "gst", e.target.value)} disabled={charge.gst_applicable === "No"} />
                </td>
                <td>
                  <InputField type="text" value={charge.gst_applicable === "No" ? "0" : charge.gst_amount || ""} onChange={(e) => handleVendorChargeInputChange(vendor.id, index, "gst_amount", e.target.value)} disabled={charge.gst_applicable === "No"} />
                </td>
                <td className="minselect">
                  <Select
                    isMulti
                    options={containerOptions}
                    value={containerOptions.filter((o) => (charge.applicableContainers || []).includes(o.value)) || null}
                    onChange={(selected) => handleVendorChargeInputChange(vendor.id, index, "applicableContainers", (selected || []).map((s) => s.value))}
                    placeholder="Select Container(s)"
                    isDisabled={containerOptions.length === 0}
                    menuPortalTarget={document.body}
                    styles={selectPortalStyles}
                  />
                </td>
                <td className="text-center">
                  <DeleteOutlineIcon
                    style={{ cursor: "pointer", color: "red", fontSize: 28 }}
                    onClick={() => deleteChargeRow(vendorIndex, index)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {vendor.chargeRows.length > 0 && (
          <div className="d-flex justify-content-end mt-2">
            <strong>Grand Total: {vendorTotal.toFixed(2)} INR</strong>
          </div>
        )}
        <div className="table-error text-danger mb-2">
          {errors.vendorTable && vendorIndex === 0 && <span>{errors.vendorTable}</span>}
          {errors[`vendor_${vendorIndex}_charges`] && <span>{errors[`vendor_${vendorIndex}_charges`]}</span>}
        </div>
      </div>
    </div>
  );
};





export default VendorPurchaseForm;
